import {
  Home,
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import React from "react";
import { Link, useLocation, useHistory, useParams } from "react-router-dom";
import { ThemeContext } from "../../../../src/context/theme/ThemeContext";
import Style from "./courseview.module.scss";
import {
  Accordion,
  Discussion,
  File,
  HeaderText,
  Meeting,
  Quiz,
  VideoJS,
} from "../../../components";

import {
  Announcement,
  DashBar,
  StudentModuleQandA,
  StudentModuleView,
  StudentSideMenu,
  Submission,
} from "../../../layout/Dashboard";

import {
  authGetRequest,
  authPostRequest,
  getRequest,
} from "../../../api/laravel/public/api";
import { styled } from "@mui/material/styles";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import Grade from "../../../layout/Dashboard/student/Grade/Grade";
import { _retrieveData, _storeData } from "../../../utils/local-storage";
import { errorMessage } from "../../../utils/notification";
import { toast } from "react-toastify";
import { SectionList } from "../../../layout/Student";
import { checkSection, getIframeLink, sumSortType } from "../../../utils/sort";




function ModuleView() {
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const [index, setIndex] = React.useState(0);
  const [data, setData] = React.useState({});
  const [view, setView] = React.useState({});
  const [tab, setTab] = React.useState({});
  const [nav, setNav] = React.useState({});
  const [inbox, setInbox] = React.useState({});
  const [announcement, setAnnouncement] = React.useState({});
  const [session, setSession] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [isPageLoader, setPageLoader] = React.useState(false);
  const [content, setContent] = React.useState({});
  const [page, setPage] = React.useState(null);
  const [mobileWidth, setMobileWidth] = React.useState(0);
  const router = useHistory();
  const { course } = useParams();
  // const { data } = getCourseItemAPI(course);
  const playerRef = React.useRef(null);
  const [event, setEvent] = React.useState({});
  const [user, setUser] = React.useState({});
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    width: '90%',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "white",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#f25f37" : "#f25f37",
    },
  }));

  React.useEffect(() => {
    window.scrollTo(0, 0);
    setMobileWidth(window.innerWidth);
  }, []);

  React.useEffect((e) => {
    getAnnouncement();
    initialApi();
    getInbox();
  }, []);

  React.useEffect(() => {
    checkUser();
    // dashboardGet();
  }, []);

  const getAnnouncement = async (id) => {
    const { data_r, isError } = await authGetRequest(`/account/announcements?course=${id}`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      return false;
    }
    setAnnouncement(data_r);
  };

  const eventsGet = async (e) => {
    // setPageLoader(true);
    // const { data_r, isError } = await authGetRequest(`/account/events`);
    // if (isError) {
    //   // errorMessage(toast, data_r?.message);
    //   setPageLoader(false);
    //   return false;
    // }
    // setEvent(data_r);
    // setPageLoader(false);
  };

  const initialApi = async () => {
    const pageData = await _retrieveData("page_data");
    if (pageData) {
      setPage(pageData);
    }
    const { data_r, message, isError, isLoading } = await getRequest(
      `/auth/api/page`
    );
    setPage(data_r);
    await _storeData(data_r, "page_data");
  };

  const checkUser = async () => {
    let storeUser = await _retrieveData('user_info');
    if (storeUser) {
      setUser(storeUser);
    }
    const { data_r, isLoading, isError, message } = await authGetRequest("/account/profile");
    if (message === "Unauthenticated.") {
      // errorMessage(toast, "Your session has expired, kindly re-login.");
      router.push("/auth/login");
    }
    else {
      await _storeData(data_r, 'user_info');
      setUser(data_r);
    }
  }

  React.useEffect(() => {
    courseViewGet();
  }, [course]);

  const courseViewGet = async () => {
    setPageLoader(true);
    let resp = await authGetRequest(`/account/dashboard/course/${course}`);
    setContent(resp.data_r);
    const { coursed, active_course_section, active_course_section_item, certificate } =
      resp?.data_r;
    if (coursed) {
      if (active_course_section_item && active_course_section_item.length > 0) {
        let active_course_section_last = active_course_section?.slice(-1)[0];
        let active_course_section_item_last =
          active_course_section_item?.slice(-1)[0];
        setSession(active_course_section_last?.course_section_id);
        viewSection(active_course_section_item_last?.course_section_item, {
          sect_id: active_course_section_last?.course_section_id,
          item_id: active_course_section_item_last?.course_section_item_id,
        });
      } else {
        viewSection(coursed?.course_section[0]?.section_item[0], {
          sect_id: coursed?.course_section[0]?.course_section_id,
          item_id: coursed?.course_section[0]?.section_item[0]?.id,
        });
      }
      getAnnouncement(coursed.id);
    }
    window.scrollTo(0, 0);
    // document.getElementById('course-top').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    setPageLoader(false);

  };

  const menuChange = (e) => {
    setIndex(e);
    window.scrollTo(0, 0);
  };

  const viewSection = async (item, tab) => {
    setPageLoader(true);

    const { data_r, message, isError, isLoading } = await authGetRequest(
      `/account/dashboard/course/item/${item?.id}`
    );
    if (isError) {
      setPageLoader(false);
      return false;
    }
    setData(data_r);
    setNav(data_r?.nav);
    setTab(tab);
    setView(data_r?.view);
    // document.getElementById('course-top').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    if (item.type === "discussion") {
      setIndex(1);
      makeActive('discussion', 'discussion-id');
      setPageLoader(false);
      // onClickLearn("discussion-learn", "learning-section");
    }
    else if (item.type === "assignment" || item.type === "project") {
      setIndex(4);
      setPageLoader(false);
      window.scrollTo(0, 0);
      makeActive('review', 'review-d');

      // onClickLearn("submission-learn", "learning-section");
    }
    else {
      setIndex(0)
    }
    setPageLoader(false);
    window.scrollTo(0, 0);
  };

  const prevLecture = () => {
    viewSection(nav?.prev, {
      sect_id: nav?.prev?.course_section_id,
      item_id: nav?.prev?.id,
    });
    // document.getElementById('top_scroll').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  };

  const nextLecture = () => {
    viewSection(nav?.next, {
      sect_id: nav?.next?.course_section_id,
      item_id: nav?.next?.id,
    });
    // document.getElementById('top_scroll').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  };

  const clickSection = async (item, tab) => {
    await viewSection(item, tab)
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    // player.on("waiting", () => {
    //   videojs.log("player is waiting");
    // });

    // player.on("dispose", () => {
    //   videojs.log("player will dispose");
    // });
  };

  const submitQuiz = async (input) => {
    let form = {};
    form["item_id"] = tab?.item_id;
    form["data"] = JSON.stringify(input);
    setLoading(true);
    let resp = await authPostRequest(`/account/dashboard/test/quiz`, form);
    setLoading(false);
    return resp.data_r;
  };

  const getInbox = async () => {
    // setLoading(true);
    // let resp = await authGetRequest(`/account/inbox`);
    // setLoading(false);
    // setInbox(resp.data_r);
  };

  const submitComment = async (input) => {
    input["item_id"] = tab?.item_id;
    let resp = await authPostRequest(`/account/dashboard/discussion-comment/submit`, input);
    return resp.data_r;
  }

  const submitCommentMore = async (input) => {
    input["item_id"] = tab?.item_id;
    let resp = await authPostRequest(`/account/dashboard/discussion-reply/submit`, input);
    return resp.data_r;
  }

  // const showComment = async (discussion) => {
  //   if (discussion) {
  //     const { data_r, isError, isLoading } = await authGetRequest(
  //       "/account/dashboard/discussions/view/" + discussion
  //     );
  //     return data_r;
  //   }
  // };

  const makeActive = (elementId, touchId) => {
    const elemented = document.getElementById(elementId);
    const touchIde = document.getElementById(touchId)
    const tabTouch = document.getElementById("tab-touch").querySelectorAll(".active");
    const tabBody = document.getElementById("tab-content").querySelectorAll(".active");
    const classUnder = document.querySelectorAll(".tabs-hr");
    tabBody.forEach((element) => {
      element.classList.remove('active');
      element.classList.remove('in');
    });
    tabTouch.forEach((element) => {
      element.classList.remove('active');
      element.classList.remove('in');
    });
    classUnder.forEach((element) => {
      element.style.display = 'none';
    });
    if (elemented.classList.contains("active")) { }
    else {
      elemented.classList.add("active");
      elemented.classList.add("in");
      touchIde.classList.add("active");
    }
  }

  return (

    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="sub-banner sub-banner-course">
          <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(http://tk-themes.net/html-megacourse/images/bg/sub-banner-course.jpg)' }} />
          <div className="awe-overlay overlay-color-2" />
          <div className="container">
            <div className="sub-banner-content">
              <h2 className="text-center">{view?.title}</h2>
            </div>
          </div>
        </section>

        <section id="" className="course-top">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="sidebar-course-intro">
                  <div className="breadcrumb">
                    <Link to="/student/home">Home</Link> /
                    <Link to="/student/courses">Courses</Link> /
                    {view?.title}
                  </div>

                  {/* CURRENT PROGRESS */}
                  <div className="current-progress">
                    <h4 className="sm black">Current Progress</h4>
                    <div className="percent">Complete <span className="count">{Math.round((data?.progress * 100) / data?.total_item > 100 ? 100 : (data?.progress * 100) / data?.total_item).toFixed(2)}%</span></div>
                    <div className="progressbar">
                      <BorderLinearProgress
                        variant="determinate"
                        value={(data?.progress * 100) / data?.total_item > 100 ? 100 : (data?.progress * 100) / data?.total_item}
                      />
                    </div>
                    <ul className="current-outline">
                      <li><span>{data?.course?.course_section?.length}</span>sections</li>
                      <li><span>{sumSortType(data?.course?.course_section, 'quiz')}</span>quizzes</li>
                      <li><span>{sumSortType(data?.course?.course_section, undefined)}</span>lectures</li>
                      <li><span>{sumSortType(data?.course?.course_section, 'project')}</span>assignments</li>
                    </ul>
                    {content?.certificate &&
                      <div className="ft-item my-4">
                        <a
                          target="_blank"
                          href={process.env.REACT_APP_HOST_URL + content?.certificate}
                          class="mc-btn-2 btn-style-2 font-bold"><span class="icon mdi1x mdi mdi-certificate"></span> Download Certificate</a>
                      </div>}
                  </div>
                  {/* END / CURRENT PROGRESS */}
                  <div className="video-course-intro">
                    <div className="video embed-responsive embed-responsive-16by9">
                      {view?.type !== "discussion" && view?.description && (
                        <div
                          className={"p-2  d_t"}
                        >
                          {view?.description}
                        </div>)}
                      <div
                      >
                        {view?.type !== "quiz" && view?.content &&
                          <div
                            className={theme === "light" ? "p-2  d_t" : "p-2  l_t"}
                            dangerouslySetInnerHTML={{
                              __html: view?.content,
                            }}
                          >
                          </div>
                        }
                        {view?.type === "video" && view?.video?.file && view?.video?.file?.ext === "mp4" && (
                          <div className="w-100">
                            <VideoJS
                              options={{
                                autoplay: false,
                                controls: true,
                                responsive: true,
                                fluid: true,
                                'playbackRates': [0.7, 1.0, 1.5, 2.0],
                                aspectRatio: mobileWidth < 500 ? '9:16' : '16:9',
                                sources: [
                                  {
                                    src: view?.video?.file?.path,
                                    type: "video/mp4",
                                  },
                                ],
                              }}
                              onReady={handlePlayerReady}
                            />
                          </div>
                        )}
                        {view?.type === "quiz" && (
                          <div className="p-2">
                            <Quiz
                              items={view?.quiz}
                              intro={view?.content}
                              quiz_submit={data?.quiz_submit}
                              total_score={data?.total_score}
                              loading={loading}
                              submitQuiz={submitQuiz}
                              nextLecture={nextLecture}
                            />
                          </div>
                        )}
                        {view?.type === "meeting" && (
                          <Meeting items={view?.meeting} loading={loading} />
                        )}
                        {view?.type === "resource" && (
                          <File items={view?.resource} loading={loading} />
                        )}
                        {view?.type === "assignment" && (
                          <File items={view?.assignment} loading={loading} />
                        )}
                        {view?.type === "project" && (
                          <File items={view?.assignment} loading={loading} />
                        )}
                        {view?.type === "discussion" && (
                          <Discussion label={view?.description} loading={loading} />
                        )}
                      </div>

                    </div>
                  </div>
                  {view?.is_download === "1" &&
                    <div className="flex">
                      {view?.type === "video" &&
                        <a href={view?.video?.file?.path ? view?.video?.file?.path : getIframeLink(view?.content)} target="_blank" className="cursor-pointer mc-btn btn-style-3 mx-2">Download Resource <i className="icon mdi2x mdi mdi-download"></i></a>}
                      {view?.assignment?.file?.path &&
                        <a href={view?.assignment?.file?.path ? view?.assignment?.file?.path : getIframeLink(view?.content)} target="_blank" className="cursor-pointer mc-btn btn-style-3 mx-2">Download Resource <i className="icon mdi2x mdi mdi-download"></i></a>}
                    </div>
                  }
                  <hr className="line" />
                  <div className="flex">
                    <a onClick={prevLecture} className="cursor-pointer mc-btn btn-style-1 mx-2">Previous Lecture </a>
                    {data?.nav?.next !== null&&<a onClick={nextLecture} className="cursor-pointer mc-btn btn-style-1 mx-2">Next Lecture</a>}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="tabs-page ">
                  <div id="tab-touch" className="nav-tabs-wrap">
                    <ul className="nav-tabs overflow-x-scroll" role="tablist">
                      <li className="active"><a href="#outline" role="tab" data-toggle="tab">Outline</a></li>
                      <li className={announcement?.length > 0 ? "itemnew" : ""}><a href="#announcement" role="tab" data-toggle="tab">Announcement</a></li>
                      <li id="discussion-id" className={view?.discussion?.id ? "itemnew" : ""}><a href="#discussion" role="tab" data-toggle="tab">Discussion</a></li>
                      <li id="review-id"><a href="#review" role="tab" data-toggle="tab">Submission</a></li>
                      <li><a href="#student" role="tab" data-toggle="tab">Grades</a></li>
                      {/* <li><a href="#updatelog" role="tab" data-toggle="tab">Update Log</a></li> */}
                      <li className="tabs-hr" style={{ left: '0px', width: '53px' }} />
                    </ul>
                  </div>
                  {/* Tab panes */}
                  <div id="tab-content" className="tab-content overflow-y-scroll">
                    {/* OUTLINE */}
                    <div className="tab-pane fade in active max-h-fit md:max-h-screen md:overflow-y-scroll" id="outline">
                      {/* SECTION OUTLINE */}
                      {data?.course?.course_section?.map((item, index) => (
                        <SectionList
                          key={index}
                          index={index}
                          id={item.id}
                          initial={session}
                          item={item}
                          tab={tab}
                          view={view}
                          progress={data?.progress}
                          title={item.title}
                          content={item.section_item}
                          sections={data?.active_course_section}
                          sectionsItem={data?.active_course_section_item}
                          onClicked={clickSection}
                        />
                      ))}
                      {/* END / SECTION OUTLINE */}

                    </div>
                    {/* END / OUTLINE */}
                    {/* ANNOUNCEMENT */}
                    <div className="tab-pane fade max-h-fit md:max-h-screen md:overflow-y-scroll" id="announcement">
                      <Announcement announcement={announcement} />
                    </div>
                    {/* END / ANNOUNCEMENT */}
                    {/* DISCUSSION */}
                    <div className="tab-pane fade max-h-fit md:max-h-screen md:overflow-y-scroll" id="discussion">
                      <StudentModuleQandA submitComment={submitComment} submitCommentMore={submitCommentMore} type={view?.type} index={view?.discussion?.id} discussion={view?.discussion?.id} />
                    </div>
                    {/* END / DISCUSSION */}
                    {/* REVIEW */}
                    <div className="tab-pane fade max-h-fit md:max-h-screen md:overflow-y-scroll" id="review">
                      <Submission
                        type={view?.type}
                        assignment={data?.assignment_submit}
                        view={view}
                        course={course}
                      />
                    </div>
                    {/* END / REVIEW */}
                    {/* STUDENT */}
                    <div className="tab-pane fade max-h-fit md:max-h-screen md:overflow-y-scroll" id="student">
                      <Grade data={data} />
                    </div>
                    {/* END / STUDENT */}
                    {/* UPDATE LOG */}
                    <div className="tab-pane fade max-h-fit md:max-h-screen md:overflow-y-scroll" id="updatelog">

                    </div>
                    {/* END / UPDATE LOG */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
}

export default ModuleView;
